import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import VerifiedUser from '@material-ui/icons/VerifiedUser';
import ImageIcon from '@material-ui/icons/Image';

import ImageGridList from '../ImageGridList';
import { POST_FILES_FOLDER, USER_FILES_FOLDER, SERVER_BASE_URL } from '../../constants';
import { parseDateToStringFormat } from '../../utils/dateUtils';

const styles = theme => ({
  paper: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    display: 'flex',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    flexGrow: 1,
  },
  paragraph: {
    marginTop: 0
  },
  email: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1.375em',
    marginLeft: 5
  }
});

class UserDetails extends Component {
  static propTypes = {
    classes: PropTypes.object,
    handleSubmit: PropTypes.func,
    removeMessage: PropTypes.func,
    error: PropTypes.string
  };

  render() {
    const {
      classes,
      postDetails
    } = this.props;

    const user = postDetails.userDetails || {};

    const imageData = postDetails.images && postDetails.images.map(p => {
      return {
        img: `${SERVER_BASE_URL}${p.image}`,
        title: 'Post Image'
      }
    });

    return (
      <React.Fragment>
        <Paper className={classes.paper}>
          <Grid container spacing={24}>
            <Grid container spacing={24}>
              <Grid item xs={1} sm={1}>
                {
                  user.image ?
                    <Avatar
                      alt="Profile Pic"
                      src={`${SERVER_BASE_URL}public/assets/${USER_FILES_FOLDER}/${user.image}`}
                      className={classes.avatar}
                    /> : <ImageIcon />
                }
                
              </Grid>
              <Grid item xs={11} sm={11}>
                <p className={classes.paragraph}>
                  <Typography variant="h6">
                    {user.firstName} {user.lastName} {user.isVerified && <VerifiedUser fontSize="small" />}
                    <span className={classes.email}>@{user.email}</span>
                  </Typography>

                  <Typography variant="caption">On {parseDateToStringFormat(postDetails.createdAt)}</Typography>
                  <p></p>
                  <Typography variant="body2">
                    {postDetails.content}
                  </Typography>
                </p>
                {imageData &&
                  <ImageGridList
                    imageData={imageData}
                  />
                }
              </Grid>
            </Grid>

          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(UserDetails);